import React, { Component, PropTypes } from 'react'
import Download from 'material-ui/svg-icons/file/cloud-download'
import RaisedButton from 'material-ui/RaisedButton'
import api from '../../api'

const fiveMinutes = 300 * 1000

class AttendeeExport extends Component<any, any> {
  constructor (props) {
    super(props)
    this.state = {
      filename: null,
      url: null,
      loading: false
    }
  }

  handleExportAttendees = () => {
    this.setState({ loading: true })
    const { webinarId } = this.props
    api.get(`admin/user_webinars/export?filters[webinar_id]=${webinarId}&filters[registered]=true`)
      .then(res => res.json())
      .then(res => {
        this.setState({ ...res, loading: false })
        setTimeout(this.handleExpiry, fiveMinutes)
      })
  }

  handleExpiry = () => {
    this.setState({ filename: null, url: null })
  }

  render () {
    const { filename, url } = this.state

    return (
      <div style={{ marginTop: '1em' }}>
        <RaisedButton
          label='Export Attendees'
          disabled={this.state.loading || this.state.filename !== null}
          primary
          icon={<Download />}
          onClick={this.handleExportAttendees}
        />
        {url &&
          <a
            style={{ marginLeft: '1em' }}
            href={url}
          >
            {filename}
          </a>}
      </div>
    )
  }
}

// @ts-ignore
AttendeeExport.propTypes = {
  webinarId: PropTypes.number.isRequired
}

export default AttendeeExport
